/**
 * @generated SignedSource<<bf655dfb41418fa87004f165bb2a1823>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentableId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsCount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsCursor"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "commentableId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentsCount",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "commentsCursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "commentsCount"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFromAdminUser",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAdmin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalViewerFields",
          "storageKey": null
        }
      ],
      "type": "Viewer",
      "abstractKey": "__isViewer"
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitComment",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "CommentAuthorizations",
  "kind": "LinkedField",
  "name": "authorizations",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiresModeration",
      "storageKey": null
    },
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentsDisplayAuthorized",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesDisplayAuthorized",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesSubmissionAuthorized",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesDownAuthorized",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submitVote",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesMode",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "up",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "down",
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unauthorizedMessages",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v17/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentViewerVote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "singleVoteMode",
      "storageKey": null
    },
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Votes",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingVotesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "limitedVotesPerUser",
      "storageKey": null
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
},
v22 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isReportable"
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCommentsCount",
      "storageKey": null
    },
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Votes",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Reactable",
  "abstractKey": "__isReactable"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v26/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": (v15/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "CommentsPanel_comments",
  "kind": "LinkedHandle",
  "name": "comments"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPanelPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "commentable",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentsPanel_commentable"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentsPanelPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "commentable",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isCommentable"
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "CommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": (v15/*: any*/),
                        "concreteType": "CommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v15/*: any*/),
                                    "concreteType": "CommentConnection",
                                    "kind": "LinkedField",
                                    "name": "comments",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CommentEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v7/*: any*/),
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              (v14/*: any*/),
                                              {
                                                "alias": null,
                                                "args": (v15/*: any*/),
                                                "concreteType": "CommentConnection",
                                                "kind": "LinkedField",
                                                "name": "comments",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Comment",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v4/*: any*/),
                                                          (v9/*: any*/),
                                                          (v10/*: any*/),
                                                          (v7/*: any*/),
                                                          (v11/*: any*/),
                                                          (v12/*: any*/),
                                                          (v14/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": (v15/*: any*/),
                                                            "concreteType": "CommentConnection",
                                                            "kind": "LinkedField",
                                                            "name": "comments",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "CommentEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Comment",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      (v9/*: any*/),
                                                                      (v10/*: any*/),
                                                                      (v7/*: any*/),
                                                                      (v11/*: any*/),
                                                                      (v12/*: any*/),
                                                                      (v14/*: any*/),
                                                                      {
                                                                        "alias": null,
                                                                        "args": (v15/*: any*/),
                                                                        "concreteType": "CommentConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "comments",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CommentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                              {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "Comment",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v4/*: any*/),
                                                                                  (v9/*: any*/),
                                                                                  (v10/*: any*/),
                                                                                  (v7/*: any*/),
                                                                                  (v11/*: any*/),
                                                                                  (v12/*: any*/),
                                                                                  (v14/*: any*/),
                                                                                  {
                                                                                    "alias": null,
                                                                                    "args": (v15/*: any*/),
                                                                                    "concreteType": "CommentConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "comments",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                      {
                                                                                        "alias": null,
                                                                                        "args": null,
                                                                                        "concreteType": "CommentEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                          {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Comment",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                              (v4/*: any*/),
                                                                                              (v9/*: any*/),
                                                                                              (v10/*: any*/),
                                                                                              (v7/*: any*/),
                                                                                              (v11/*: any*/),
                                                                                              (v12/*: any*/),
                                                                                              (v14/*: any*/),
                                                                                              {
                                                                                                "alias": null,
                                                                                                "args": (v15/*: any*/),
                                                                                                "concreteType": "CommentConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "comments",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                  {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "CommentEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                      {
                                                                                                        "alias": null,
                                                                                                        "args": null,
                                                                                                        "concreteType": "Comment",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "node",
                                                                                                        "plural": false,
                                                                                                        "selections": [
                                                                                                          (v4/*: any*/),
                                                                                                          (v9/*: any*/),
                                                                                                          (v10/*: any*/),
                                                                                                          (v7/*: any*/),
                                                                                                          (v11/*: any*/),
                                                                                                          (v12/*: any*/),
                                                                                                          (v14/*: any*/),
                                                                                                          {
                                                                                                            "alias": null,
                                                                                                            "args": (v15/*: any*/),
                                                                                                            "concreteType": "CommentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "comments",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                              {
                                                                                                                "alias": null,
                                                                                                                "args": null,
                                                                                                                "concreteType": "CommentEdge",
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "edges",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                  {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "concreteType": "Comment",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                      (v4/*: any*/),
                                                                                                                      (v9/*: any*/),
                                                                                                                      (v10/*: any*/),
                                                                                                                      (v7/*: any*/),
                                                                                                                      (v11/*: any*/),
                                                                                                                      (v12/*: any*/),
                                                                                                                      (v14/*: any*/),
                                                                                                                      {
                                                                                                                        "alias": null,
                                                                                                                        "args": (v15/*: any*/),
                                                                                                                        "concreteType": "CommentConnection",
                                                                                                                        "kind": "LinkedField",
                                                                                                                        "name": "comments",
                                                                                                                        "plural": false,
                                                                                                                        "selections": [
                                                                                                                          {
                                                                                                                            "alias": null,
                                                                                                                            "args": null,
                                                                                                                            "concreteType": "CommentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                              {
                                                                                                                                "alias": null,
                                                                                                                                "args": null,
                                                                                                                                "concreteType": "Comment",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "node",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                  (v4/*: any*/),
                                                                                                                                  (v9/*: any*/),
                                                                                                                                  (v10/*: any*/),
                                                                                                                                  (v7/*: any*/),
                                                                                                                                  (v11/*: any*/),
                                                                                                                                  (v12/*: any*/),
                                                                                                                                  (v14/*: any*/),
                                                                                                                                  (v5/*: any*/),
                                                                                                                                  (v21/*: any*/),
                                                                                                                                  (v22/*: any*/),
                                                                                                                                  (v23/*: any*/)
                                                                                                                                ],
                                                                                                                                "storageKey": null
                                                                                                                              },
                                                                                                                              (v24/*: any*/)
                                                                                                                            ],
                                                                                                                            "storageKey": null
                                                                                                                          },
                                                                                                                          (v27/*: any*/)
                                                                                                                        ],
                                                                                                                        "storageKey": "comments(first:2147483647)"
                                                                                                                      },
                                                                                                                      (v28/*: any*/),
                                                                                                                      (v5/*: any*/),
                                                                                                                      (v21/*: any*/),
                                                                                                                      (v22/*: any*/),
                                                                                                                      (v23/*: any*/)
                                                                                                                    ],
                                                                                                                    "storageKey": null
                                                                                                                  },
                                                                                                                  (v24/*: any*/)
                                                                                                                ],
                                                                                                                "storageKey": null
                                                                                                              },
                                                                                                              (v27/*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": "comments(first:2147483647)"
                                                                                                          },
                                                                                                          (v28/*: any*/),
                                                                                                          (v5/*: any*/),
                                                                                                          (v21/*: any*/),
                                                                                                          (v22/*: any*/),
                                                                                                          (v23/*: any*/)
                                                                                                        ],
                                                                                                        "storageKey": null
                                                                                                      },
                                                                                                      (v24/*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                  },
                                                                                                  (v27/*: any*/)
                                                                                                ],
                                                                                                "storageKey": "comments(first:2147483647)"
                                                                                              },
                                                                                              (v28/*: any*/),
                                                                                              (v5/*: any*/),
                                                                                              (v21/*: any*/),
                                                                                              (v22/*: any*/),
                                                                                              (v23/*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                          },
                                                                                          (v24/*: any*/)
                                                                                        ],
                                                                                        "storageKey": null
                                                                                      },
                                                                                      (v27/*: any*/)
                                                                                    ],
                                                                                    "storageKey": "comments(first:2147483647)"
                                                                                  },
                                                                                  (v28/*: any*/),
                                                                                  (v5/*: any*/),
                                                                                  (v21/*: any*/),
                                                                                  (v22/*: any*/),
                                                                                  (v23/*: any*/)
                                                                                ],
                                                                                "storageKey": null
                                                                              },
                                                                              (v24/*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                          },
                                                                          (v27/*: any*/)
                                                                        ],
                                                                        "storageKey": "comments(first:2147483647)"
                                                                      },
                                                                      (v28/*: any*/),
                                                                      (v5/*: any*/),
                                                                      (v21/*: any*/),
                                                                      (v22/*: any*/),
                                                                      (v23/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  },
                                                                  (v24/*: any*/)
                                                                ],
                                                                "storageKey": null
                                                              },
                                                              (v27/*: any*/)
                                                            ],
                                                            "storageKey": "comments(first:2147483647)"
                                                          },
                                                          (v28/*: any*/),
                                                          (v5/*: any*/),
                                                          (v21/*: any*/),
                                                          (v22/*: any*/),
                                                          (v23/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v24/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v27/*: any*/)
                                                ],
                                                "storageKey": "comments(first:2147483647)"
                                              },
                                              (v28/*: any*/),
                                              (v5/*: any*/),
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v24/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v27/*: any*/)
                                    ],
                                    "storageKey": "comments(first:2147483647)"
                                  },
                                  (v28/*: any*/),
                                  (v5/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v24/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": "comments(first:2147483647)"
                      },
                      (v28/*: any*/),
                      (v5/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v25/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "CommentsPanel_comments",
            "kind": "LinkedHandle",
            "name": "comments"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "authorizations",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v13/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c92bd0fc124cd4adf1ed2db095114456",
    "id": null,
    "metadata": {},
    "name": "CommentsPanelPaginationQuery",
    "operationKind": "query",
    "text": "query CommentsPanelPaginationQuery(\n  $commentsCount: Int!\n  $commentsCursor: String\n  $commentableId: ID!\n) {\n  commentable(id: $commentableId) {\n    __typename\n    id\n    ...CommentsPanel_commentable\n  }\n}\n\nfragment CommentCard_comment on Comment {\n  id\n  content\n  createdAt\n  commentsCount\n  isFromAdminUser\n  author {\n    __typename\n    name\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  authorizations {\n    requiresModeration\n    submitComment\n    commentsDisplayAuthorized\n    votesDisplayAuthorized\n    votesSubmissionAuthorized\n    id\n  }\n  ...VoteButtons_votable\n  ...Report_reportable\n  ...ReactableMeasures_reactable\n}\n\nfragment Comment_comment on Comment {\n  id\n  title\n  ...CommentCard_comment\n  isFromAdminUser\n  comments(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...CommentCard_comment\n        comments(first: 2147483647) {\n          edges {\n            node {\n              id\n              ...CommentCard_comment\n              comments(first: 2147483647) {\n                edges {\n                  node {\n                    id\n                    ...CommentCard_comment\n                    comments(first: 2147483647) {\n                      edges {\n                        node {\n                          id\n                          ...CommentCard_comment\n                          comments(first: 2147483647) {\n                            edges {\n                              node {\n                                id\n                                ...CommentCard_comment\n                                comments(first: 2147483647) {\n                                  edges {\n                                    node {\n                                      id\n                                      ...CommentCard_comment\n                                      comments(first: 2147483647) {\n                                        edges {\n                                          node {\n                                            id\n                                            ...CommentCard_comment\n                                            comments(first: 2147483647) {\n                                              edges {\n                                                node {\n                                                  id\n                                                  ...CommentCard_comment\n                                                  comments(first: 2147483647) {\n                                                    edges {\n                                                      node {\n                                                        id\n                                                        ...CommentCard_comment\n                                                        __typename\n                                                      }\n                                                      cursor\n                                                    }\n                                                    pageInfo {\n                                                      endCursor\n                                                      hasNextPage\n                                                    }\n                                                  }\n                                                  __typename\n                                                }\n                                                cursor\n                                              }\n                                              pageInfo {\n                                                endCursor\n                                                hasNextPage\n                                              }\n                                            }\n                                            __typename\n                                          }\n                                          cursor\n                                        }\n                                        pageInfo {\n                                          endCursor\n                                          hasNextPage\n                                        }\n                                      }\n                                      __typename\n                                    }\n                                    cursor\n                                  }\n                                  pageInfo {\n                                    endCursor\n                                    hasNextPage\n                                  }\n                                }\n                                __typename\n                              }\n                              cursor\n                            }\n                            pageInfo {\n                              endCursor\n                              hasNextPage\n                            }\n                          }\n                          __typename\n                        }\n                        cursor\n                      }\n                      pageInfo {\n                        endCursor\n                        hasNextPage\n                      }\n                    }\n                    __typename\n                  }\n                  cursor\n                }\n                pageInfo {\n                  endCursor\n                  hasNextPage\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CommentsList_comments on Comment {\n  id\n  ...Comment_comment\n}\n\nfragment CommentsPanel_commentable on Commentable {\n  __isCommentable: __typename\n  id\n  title\n  commentsCount\n  comments(first: $commentsCount, after: $commentsCursor) {\n    edges {\n      node {\n        ...CommentsList_comments\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n  authorizations {\n    __typename\n    submitComment\n    id\n  }\n}\n\nfragment DownVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    down\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment Report_reportable on Reportable {\n  __isReportable: __typename\n  id\n}\n\nfragment UpVoteButton_votable on Votable {\n  __isVotable: __typename\n  id\n  currentViewerVote\n  singleVoteMode\n  votesMode\n  authorizations {\n    __typename\n    submitVote\n    unauthorizedMessages {\n      __typename\n      submitVote\n      id\n    }\n    id\n  }\n  votes {\n    id\n    up\n  }\n  ...useVoteButtonsLabel_votable\n  ...VoteButton_votable\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n\nfragment VoteButton_votable on Votable {\n  __isVotable: __typename\n  remainingVotesCount\n  limitedVotesPerUser\n}\n\nfragment VoteButtons_votable on Votable {\n  __isVotable: __typename\n  authorizations {\n    __typename\n    votesSubmissionAuthorized\n    votesDownAuthorized\n    id\n  }\n  ...UpVoteButton_votable\n  ...DownVoteButton_votable\n}\n\nfragment useVoteButtonsLabel_votable on Votable {\n  __isVotable: __typename\n  votesMode\n  currentViewerVote\n  singleVoteMode\n  ...VoteButton_votable\n}\n"
  }
};
})();

node.hash = "1d16a6134786718ddefd7a00de6d77c6";

module.exports = node;
